import { addMonths, format } from 'date-fns'

// 신규 이용 현황 화면 노출 시작 월. 이 월 이상만 신규 화면으로 그리고, 미만은 응답에 청구 정보가
// 있더라도 기존(결제 예상 금액) 화면으로 보낸다.
export const USAGE_API_BREAK_YEAR_MONTH = '2026-10'

const yearMonthToNumber = (yearMonth: string) => Number(yearMonth.replace('-', ''))

export const isBeforeApiBreak = (date: Date) =>
  yearMonthToNumber(format(date, 'yyyy-MM')) < yearMonthToNumber(USAGE_API_BREAK_YEAR_MONTH)

// 날짜와 무관하게 다음 달까지 연다. 다음 달 추가 과금 구간이 시작 전이면 서버가 추가 과금 0 으로 답한다.
//
// 결제 종료일로 막지 않는다. 플랜을 바꾸면 뒤에 구독이 예약돼 있어도 종료일이 현재 구독의
// 마지막 날로 갱신되는데, 정작 그 케이스가 다음 달 금액을 가장 많이 묻는다.
export const getMaxInquiryDate = (today: Date) => addMonths(today, 1)

// 금액 표기가 '예상 금액' → '결제 금액'으로 넘어가기 전까지 남는 일수.
// 결제일 25일 기준 23일까지 예상이라는 정책을 결제일 상대값으로 옮긴 것이라, 결제일이 다른 학원도 따라간다.
const ESTIMATE_DAYS_BEFORE_PAY_DATE = 2

/**
 * 조회월 금액을 '예상'으로 적을지. 미래월은 항상 예상, 과거월은 항상 확정,
 * 당월은 결제일 이틀 전까지만 예상이다.
 *
 * 응답의 billing.estimated 는 청구서 생성 여부(결제일 사흘 전)라 이 표기 정책과 어긋나 쓰지 않는다.
 */
export const isEstimatedMonth = (target: Date, today: Date, payDayOfMonth: number) => {
  const monthDiff =
    yearMonthToNumber(format(target, 'yyyy-MM')) - yearMonthToNumber(format(today, 'yyyy-MM'))

  if (monthDiff !== 0) return monthDiff > 0

  return today.getDate() <= payDayOfMonth - ESTIMATE_DAYS_BEFORE_PAY_DATE
}

// 자세히보기 링크와 카운트 단위를 가르는 사용량 분류. 서버가 enum 을 문서화하지 않아
// dev 실응답에서 관측한 값만 담았고, 모르는 값은 categoryDescription 을 그대로 노출한다.
export const USAGE_CATEGORY = {
  SMS: 'SMS_USAGE',
  LMS: 'LMS_USAGE',
  HWP: 'MY_DB_HWP_DOWNLOAD',
  PER_STUDENT: 'PER_STUDENT',
} as const
